import React, { useEffect, useState } from "react";
import { Box, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import apiService from "../../../../service/Api";
import { tokens } from "../../../../theme";

interface ApiEmailVariable {
  id: number;
  name: string;
  description: string;
  example: string;
  category: string;
}

interface InsertVariableMenuProps {
  onInsert: (variableKey: string) => void;
}

const InsertVariableMenu: React.FC<InsertVariableMenuProps> = ({
  onInsert,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [variables, setVariables] = useState<ApiEmailVariable[]>([]);
  const open = Boolean(anchorEl);

  useEffect(() => {
    apiService
      .get<{ results: ApiEmailVariable[] } | ApiEmailVariable[]>(
        "/api/configurations/email-variables/?page_size=100",
      )
      .then((res) =>
        setVariables(Array.isArray(res.data) ? res.data : res.data.results ?? []),
      )
      .catch(() => setVariables([]));
  }, []);

  const handleSelect = (key: string) => {
    onInsert(key);
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          color: colors.primary[400],
          fontSize: "0.8rem",
          fontWeight: 500,
          "&:hover": { opacity: 0.75 },
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Insert variable
        </Typography>
        <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "12px",
              mt: 0.5,
              minWidth: 200,
            },
          },
        }}
      >
        {variables.map((v) => (
          <MenuItem
            key={v.id}
            onClick={() => handleSelect(`{{${v.name}}}`)}
            sx={{ fontSize: "0.85rem", py: 1 }}
          >
            <Box>
              <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
                {v.description}
              </Typography>
              <Typography variant="caption" sx={{ color: colors.primary[300] }}>
                {`{{${v.name}}}`}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default InsertVariableMenu;
